import React, { useState, useEffect, useCallback } from 'react';
import api from '@/lib/api';
import { PersonalInformationPanel } from '@/components/profile/PersonalInformationPanel';
import { VestingStatusPanel } from '@/components/profile/VestingStatusPanel';
import { AddressesPanel } from '@/components/profile/AddressesPanel';
import { BeneficiariesPanel } from '@/components/profile/BeneficiariesPanel';

export const ProfilePage = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  const load = useCallback(async () => {
    try {
      const res = await api.get('/participant/profile');
      setProfile(res.data);
      setErr('');
    } catch (e) {
      setErr(e?.response?.data?.detail || 'Unable to load profile.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) {
    return (
      <div className="panel p-6 animate-pulse" data-testid="profile-loading">
        <div className="h-4 bg-gray-100 rounded w-48 mb-3" />
        <div className="h-40 bg-gray-50 rounded" />
      </div>
    );
  }
  if (err) {
    return (
      <div className="panel p-5 border-red-200" data-testid="profile-error">
        <p className="text-sm text-red-600">{err}</p>
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="profile-page">
      <h1
        className="text-lg font-semibold text-[#1B2A4A]"
        style={{ fontFamily: 'IBM Plex Sans' }}
      >
        Account Profile
      </h1>
      <PersonalInformationPanel profile={profile} onProfileUpdate={load} />
      <VestingStatusPanel />
      <AddressesPanel />
      <BeneficiariesPanel />
    </div>
  );
};

export default ProfilePage;
